/* global gtag */
/* eslint prefer-const: */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array';
import Vue from 'vue';
import OktaVue from '@okta/okta-vue';
import VeeValidate, { Validator } from 'vee-validate';
import { OktaAuth } from '@okta/okta-auth-js';
import BootstrapVue from 'bootstrap-vue';
import VModal from 'vue-js-modal';
import VuejsDialog from 'vuejs-dialog';
import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon';
import RotateLoader from 'vue-spinner/src/RotateLoader';
import VueTheMask from 'vue-the-mask';
import customValidatorRules from './services/validatorRules';
import store from './store/store';
import App from './App';
import router from './router';
import veeConfig from './custom-error-messages';
import Security from "./security/security";
import money from '../modules/v-money'; // TODO: Create a different plugin to add commas to numbers
import oktaConfig from './okta-config';
import { customConfig } from '../config/config.js';

if (process.env.IS_OKTA_LOGIN_ENABLED) {
  const oktaAuth = new OktaAuth(oktaConfig.oidc);
  Vue.use(OktaVue, { oktaAuth });
  Vue.use(Security);
}
Vue.use(BootstrapVue);
Vue.use(VModal);
Vue.config.productionTip = false;
Vue.config.errorHandler = function (err, vm, info) {
  window.console.warn(`Vue ${info} : ${err}`);
  gtag('event', 'exception', {
    description: `Vue ${info} : ${err}`,
    fatal: false, // set to true if the error is fatal
  });
};

/* global-level-component-registration */

Vue.component('icon', Icon);
Vue.component('rotate-loader', RotateLoader);

/* Import vee-validate rules */
const customRulesKeys = Object.keys(customValidatorRules);

customRulesKeys.forEach((key) => {
  Validator.extend(key, customValidatorRules[key]);
});

/* Vee validate module for form validtaions  */
Vue.use(VeeValidate, veeConfig);
Vue.prototype.appConfig = customConfig;

Vue.use(VueTheMask);
Vue.use(money, { precision: 0 });
/* Vue confirmation dialog box */
Vue.use(VuejsDialog);
/* eslint func-names: ["error", "never"] */
/* eslint prefer-arrow-callback:  */
Vue.filter('currency-filter', function (value) {
  return Number(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
});
/* eslint no-new: */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
});




// WEBPACK FOOTER //
// ./src/main.js